// extracted by mini-css-extract-plugin
export default {"confirm":"TpnSettingsModal_confirm__0OQz-","copy":"TpnSettingsModal_copy__IYps1","help":"TpnSettingsModal_help__-6JAh","message":"TpnSettingsModal_message__dM81F"};